import React from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';

function initGA(): void {
    const gaId = process.env.REACT_APP_GOOGLE_ANALYTIC_ID;
    if (typeof gaId !== 'undefined') {
        ReactGA.initialize(gaId);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }
}

initGA();

export default class Application extends React.Component {
    render() {
        return (
            <div className='application'>
                <Helmet>
                    <title>DYL Editor</title>
                    <meta
                        name='title'
                        content='DYL Editor - Edit Video And Audio'
                    />
                    <meta
                        name='description'
                        content='DYL Editor is a photo and video editing website under DYL Download Facebook Video Extension'
                    />
                </Helmet>
            </div>
        );
    }
}
